import { apiRequest } from './apiClient';
import {
  EmpresaRepresentante,
  EmpresaResumo,
  Paginated,
  PapelOperacional,
  UsuarioEmpresa,
  UsuarioResumo,
  VinculoStatus,
} from '../types/usuariosEmpresa';

function queryString(values: Record<string, string | number | undefined>): string {
  const query = new URLSearchParams();
  Object.entries(values).forEach(([key, value]) => {
    if (value !== undefined && value !== '') query.set(key, String(value));
  });
  const result = query.toString();
  return result ? `?${result}` : '';
}

export function listarEmpresasAcessiveis(token: string): Promise<Paginated<EmpresaResumo>> {
  return apiRequest<Paginated<EmpresaResumo>>('/empresas?pageSize=100', token);
}

export function listarUsuariosDisponiveis(token: string): Promise<Paginated<UsuarioResumo>> {
  return apiRequest<Paginated<UsuarioResumo>>('/usuarios?pageSize=100', token);
}

export function listarVinculos(
  token: string,
  empresaId: string,
  filters: { search?: string; papel?: string; status?: string },
): Promise<Paginated<UsuarioEmpresa>> {
  return apiRequest<Paginated<UsuarioEmpresa>>(
    `/empresas/${empresaId}/usuarios${queryString({ ...filters, pageSize: 100 })}`,
    token,
  );
}

export function vincularUsuario(
  token: string,
  empresaId: string,
  payload: { usuarioId: string; papelOperacional: PapelOperacional },
): Promise<UsuarioEmpresa> {
  return apiRequest<UsuarioEmpresa>(`/empresas/${empresaId}/usuarios`, token, {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export function atualizarVinculo(
  token: string,
  empresaId: string,
  usuarioId: string,
  payload: { papelOperacional?: PapelOperacional; status?: VinculoStatus },
): Promise<UsuarioEmpresa> {
  return apiRequest<UsuarioEmpresa>(`/empresas/${empresaId}/usuarios/${usuarioId}`, token, {
    method: 'PATCH',
    body: JSON.stringify(payload),
  });
}

export function listarRepresentantes(
  token: string,
  empresaId: string,
  filters: { search?: string; status?: string },
): Promise<Paginated<EmpresaRepresentante>> {
  return apiRequest<Paginated<EmpresaRepresentante>>(
    `/empresas/${empresaId}/representantes${queryString({ ...filters, pageSize: 100 })}`,
    token,
  );
}

export function criarRepresentante(
  token: string,
  empresaId: string,
  payload: { nome: string; email?: string; telefone?: string; cargo?: string },
): Promise<EmpresaRepresentante> {
  return apiRequest<EmpresaRepresentante>(`/empresas/${empresaId}/representantes`, token, {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export function atualizarRepresentante(
  token: string,
  empresaId: string,
  representanteId: string,
  payload: { status: VinculoStatus },
): Promise<EmpresaRepresentante> {
  return apiRequest<EmpresaRepresentante>(
    `/empresas/${empresaId}/representantes/${representanteId}`,
    token,
    { method: 'PATCH', body: JSON.stringify(payload) },
  );
}
